import { useRouter } from 'next/router'
import Script from 'next/script'
import React from 'react'

export const trackMixpanelEvent = (
  event_name: string,
  props?: Record<any, any>,
) => {
  try {
    if ((window as any).mixpanel) {
      ; (window as any).mixpanel.track(event_name, { ...props, funnel: '8am' })
      console.log('MPF', event_name)
    }
  } catch (e) {
    console.log(e)
  }
}

export const MixpanelTracker = function () {
  const router = useRouter()

  const handleRouteChange = (url: any) => {
    // Send track event on every page view.
    trackMixpanelEvent('Page view', { url })
  }

  React.useEffect(() => {
    router.events.on('routeChangeComplete', handleRouteChange)
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange)
    }
  }, [router.asPath, router.events])
  return null
}
